module.exports = __webpack_public_path__ + "static/media/minus.c7194269.svg";